import { render, staticRenderFns } from "./PickReportform.vue?vue&type=template&id=0cb656ff&scoped=true"
import script from "./PickReportform.vue?vue&type=script&lang=js"
export * from "./PickReportform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb656ff",
  null
  
)

export default component.exports